import type { Jsonifiable } from '../_shared';
import { SessionStorageBase } from '../_shared';

enum IdempotencyKeyStorageKey {
  PayflowIdempotency = 'payflow-idempotency-key',
}

export class IdempotencyKeySessionStorage extends SessionStorageBase {
  public loadIdempotencyKey(accountId?: number) {
    return this.load(this.getKey(IdempotencyKeyStorageKey.PayflowIdempotency, accountId));
  }

  public saveIdempotencyKey(data: Jsonifiable, accountId?: number) {
    return this.save(this.getKey(IdempotencyKeyStorageKey.PayflowIdempotency, accountId), data);
  }

  public clearIdempotencyKey(accountId?: number) {
    return this.clear(this.getKey(IdempotencyKeyStorageKey.PayflowIdempotency, accountId));
  }
}

export const idempotencyKeySessionStorage = new IdempotencyKeySessionStorage();
